import script from "./BillDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./BillDetailView.vue?vue&type=script&setup=true&lang=js"

import "./BillDetailView.vue?vue&type=style&index=0&id=dd735732&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd735732"]])

export default __exports__